import domReady from '@wordpress/dom-ready';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { tablet } from './../../settings';
gsap.registerPlugin(ScrollTrigger);

domReady(() => {
	const footer = document.querySelector('#footer');
	const body = document.querySelector('body');
	if (footer && !body.classList.contains('error404')) {
		const footerWrapper = footer.querySelector('.footer-wrapper');
		const previous = footer.parentNode.previousElementSibling;
		let mm = gsap.matchMedia();

		mm.add(`(min-width: ${tablet}px)`, () => {
			gsap.set(footerWrapper, { yPercent: -50 });
			const uncover = gsap.timeline({ paused: true });
			uncover.to(footerWrapper, { yPercent: 0, ease: 'none' });
			ScrollTrigger.create({
				trigger: previous,
				start: 'bottom bottom',
				end: () => `+=${footer.offsetHeight}px`,
				animation: uncover,
				scrub: true,
			});
		});
	}
});
